import styled from 'styled-components';
import {Icon} from '../../../../elements/Icon/Icon';
export const ToggleHandle = styled.span`
    position: absolute;
    border-radius: 10px;
    transition: left 0.15s ease-out 0s;
    top: 50%;
    transform: translateY(-50%);
    background-color: var(--toggle-handle-bg);

    ${Icon.Wrapper} {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @-moz-document url-prefix() {
            top: calc(50% - 1px);
        }
    }
`;

export const ToggleBackground = styled.span`
    position: relative;
    background: var(--toggle-container-bg);
    border-radius: 50px;
    display: block;
    font-size: var(--text-size-x-small);
    position: relative;
    text-transform: uppercase;
    transition: all 0.15s ease-out 0s;
    flex-shrink: 0;
    margin-right: 4px;
`;
